export default {
  softDeletedInfluencerAlert: {
    title: '该达人暂时无法合作',
    description: '{creatorName} 的账号暂时受到 {platform} 限制，目前无法发布新内容。在限制解除前，本次合作将暂停。',
    support: '如需任何帮助，请联系您的客户支持团队或发送邮件至',
  },
  // AI 标签相关
  aiRecommendationReasons: '推荐理由',
  download: '下载',
  copy: '复制',
  viewMore: '展开更多',
  showLess: '收起',
  
  // 稿件状态
  manuscriptStates: {
    influencerApplied: '表达合作意向',
    dealConfirmed: '合作已确认',
    ahaPicksOffer_sendquote: '已请求报价',
    ahaPicksOffer_sendoffer: '发送报价',
    kickoffProduction: '启动制作',
    submitAddress: '填写收货信息',
    productShipped: '发货信息',
    productArrived: '已到货',
    submitAccount: '提交账号',
    script: '方案/脚本',
    videoDraft1: '1 稿',
    videoDraft2: '2 稿',
    videoDraft3: '3 稿',
    videoDraft4: '4 稿',
    videoDraft5: '5 稿',
    finalLink: '终稿',
    applicationRejected: '申请已拒绝',
  },
  
  // 标签页
  tabs: {
    overview: '概览',
    contentDelivery: '内容交付'
  },

  // 反馈相关
  feedback: {
    congratulations: '恭喜完成本次合作！很想听听您对这位达人的真实感受。您的反馈十分宝贵，将帮助我持续优化后续合作体验。',
    thankYou: '感谢您的反馈！我会继续为您优化营销效果。若对此次合作还有更多想法，随时告诉我，我会持续迭代优化。'
  },

  // Toast 消息
  toast: {
    notMatchMessage: '没有看到理想匹配？当前结果基于您的受众画像信息生成。试着调整营销计划信息（受众、核心卖点等）以提升匹配质量。',
    editSettings: '调整设置'
  },

  // 错误消息
  errors: {
    getApplyListFailed: '获取当前计划的申请列表失败：'
  },

  // 受众分布
  audienceDistribution: {
    title: '受众分布',
    unknown: '未知',
    firstMenuItem: '第 1 个菜单项',
    clickingMeWillNotClose: '点击我不会关闭菜单。',
    clickingMeWillClose: '点击我将关闭菜单。'
  },

  // 受众概览
  audienceOverview: {
    // 加载状态
    loading: {
      keyMetrics: '关键指标',
      audienceInsights: '受众画像洞察',
      topGeographies: '主要市场国家',
      age: '年龄',
      gender: '性别'
    },
    // 关键指标
    pastCollaborations: '过往合作',
    keyMetrics: '关键指标(最近20篇)',
    audienceInsights: '达人画像匹配',
    collaborationRisk: "品牌安全",
    collaborationRiskDescription: "分析达人过往内容中的视频记录、音频、视觉内容和文本，以保护您的品牌安全。",
    contentQuality: {
      title: "内容质量",
      originality: "原创性",
      productionQuality: "生产质量",
    },
    basicInformation: '基础信息 (AI 推断)',
    deliveryRecord: '交付记录',
    viewMore: '查看更多',
    // 价格相关
    bestPrice: '合作价格',
    save: '节约',
    recruitmentCost: '招募成本',
    lowestCpm: '最低 CPM',
    commissionRate: '佣金比例',
    predictedClicks: '预测点击',
    predictedClicksTips: '点击量是基于过往合作和达人近期表现预测得出的，剔除了异常数据以确保估算反映真实互动情况。',
    predictedCpc: '预测 CPC',
    predictedCpcTips: 'CPC (每次点击成本) 是基于达人最佳价格和预测点击量计算得出的，显示每次点击预计花费金额。',
    brandedContentPredictedViews: '品牌内容预测播放量',
    // 工具提示
    tooltips: {
      lowerPriceIntent: '为表达强烈合作意愿，该达人将报价降至低于平台建议价。',
      lowestPriceCalculation: '最低价格的计算方式为：将最低CPM乘以该达人品牌内容的预测浏览量。CPM体现了达人的受众价值，而受众价值由以下因素决定：受众画像价值、国家/地区价值、平台价值以及内容相关性价值。',
      physicalProductSubsidy: 'AhaCreator 可按商品零售价最高抵扣 60%，用于抵扣达人付款。',
      predictedCpcUnavailable: '由于历史信息不足，暂无法提供该达人的预测 CPC。',
      topMatch: '优选匹配'
    },
    // AI 营销相关
    aiGenerated: 'AI 生成',
    aiGeneratedTooltip: '达人画像由 AhaCreator 基于达人的内容、文案与个人简介分析生成。',
    aiAgentsNegotiated: 'AI智能代理已根据受众价值（包括国家/地区价值、受众画像、平台属性和内容相关性）以及预测的品牌内容浏览量，与达人协商出最优价格。',
    // 受众匹配
    overallMatchingScore: '匹配分',
    audienceName: '名称',
    description: '描述',
    noMatchingInfluencerProfile: '暂无匹配达人画像',
    defaultMatchingReason:
      '基于内容主题，该达人与您的产品信息有一定相关性，并可能触达您的目标受众。',
    collapse: '收起'
  },

  // 订单详情头部
  orderDetailHeader: {
    previous: '上一个',
    next: '下一个',
    // 倒计时相关
    countdown: {
      leftToEnterShipping: '距离填写收货信息截止还有',
      leftToReview: '剩余审核时间，',
      didNotTakeAction: '您未在此时间前完成操作：',
      influencerWithdrawn: '，因此该达人已退出本次合作。',
      reviewPrompt: '及时的审核能建立信任，并让你的活动保持在正轨上。',
      withdrawPrompt: '倒计时结束后，达人可能会退出合作。',
      timelineExtensionPrompt: '时间线延长。如果未采取任何行动，请求将自动获批。',
      pendingAccountSetup: '内确认开通达人权限。'
    },
    // 导航相关
    navigation: {
      of: '共'
    }
  },

  // 订单详情主要内容
  orderDetailMain: {
    // 内容信息
    contentInformation: '内容信息',
    // 跟踪链接
    dedicatedTrackingLink: '该达人的专属转化追踪链接：',
    dedicatedTrackingLinkDescription: '供达人在内容中使用的专属追踪链接，用于统计点击与 CPC 表现。',
    // 热门内容
    hitContent: '爆款内容',
    hitContentDescription: '基于对您产品的理解，AI 为您精选了过往的爆款案例，便于达人在本次计划中参考借鉴。'
  },

  // 订单达人信息
  orderInfluencer: {
    influencerRate: "达人价格",
    rateHistory: "报价历史",
    openingQuote: "您的初始报价",
    medianViews: "中位观看量",
    medianCpm: "中位CPM",
    deliverable: "交付内容",
    overall: "整体",
    recommendationReason: "推荐理由",
    matchAnalysis: "匹配分析",
    influencerProfile: "达人画像",
    matchReason: "匹配原因",
    basicInformation: {
      accountType: "账号类型",
      ageRange: "年龄范围",
      facePresentationDetail: "面容展示",
      gender: "性别",
      showsFace: "是否露脸",
      primaryLanguages: "主要语言",
      voiceoverDetail: "口播",
      languageFluency: "语言流利度",
      accent: "口音",
      otherLanguages: "其他语言",
    },
    // 按钮文案
    buttons: {
      postponeTimeline: '延后时间线',
      remove: '移除',
      confirm: '确认',
      completeCollaboration: '完成合作',
      enterShippingInfo: '填写收货信息',
      terminateCollaboration: '终止合作'
    },
    // 客服描述消息
    customerService: {
      contentSubmissionMissed: '您好 {firstName}，更新一下：该达人已错过内容提交截止时间。我正通过邮件与私信等多种方式积极催促其尽快提交。与此同时，您也可以选择取消本次合作并获得 100% 退款（含平台服务费）。',
      productionNotStarted: '您好 {firstName}，更新一下：该达人尚未开始内容制作。我正通过邮件与私信等多种方式积极推进制作进度。若您愿意，也可取消本次合作并获得 100% 退款（含平台服务费）。',
      shippingAddressMissed: '您好 {firstName}，更新一下：该达人已错过收货地址提交截止时间。我正通过多种渠道积极跟进和催促。期间，您也可以选择取消本次合作并获得 100% 退款（含平台服务费）。',
      slightlyBehindSchedule: '您好 {firstName}，小更新：该达人进度略有滞后。我们的 AI 已通过多渠道积极跟进以加快推进。感谢耐心等待，我们会持续同步最新进展！'
    },
    // 错误消息
    errors: {
      networkError: '网络错误！'
    },
    viewMore: '查看更多',
    matchedFrom: '基于您在计划信息中输入的品牌（{brandName}），包括相关或以往合作过的达人。',
    // 唯一链接提示
    uniqueLinkAlert: {
      title: '填写唯一链接',
      description: '发布内容时，将要求该达人添加此唯一链接，并将其受众引导至该链接。',
      enterButton: '填写'
    },
    ahaPicksPassedOnOfferTitle: '达人已拒绝',
    ahaPicksRejectReasonTypes: {
      proposedPriceNotAttractive: '报价没有吸引力',
      productDoesNotFit: '产品与我的内容/频道不匹配',
      others: '其他',
    },
    audienceNotMatch: {
      title: '<b>该达人的受众</b> 仅部分匹配您的目标受众。您可以酌情批准或拒绝。',
    },
  },

  // 平台和内容类型
  platformAndContentType: {
    // 营销策略
    marketingStrategy: {
      influencerMarketing: '达人营销',
      affiliateMarketing: '分销营销'
    }
  },

  // 相同达人标记
  sameInfluencerMark: {
    // 工具提示
    tooltip: {
      description: '该达人来源于您的参考达人列表',
      linkText: '查看参考'
    },
    // 标签文案
    label: '来自参考达人匹配'
  },

  // 物流状态
  carrierStatus: {
    // 状态文案
    status: {
      pending: '待寄送',
      fulfilled: '已寄出',
      delivered: '已送达',
      error: '跟踪错误'
    },
    // 弹窗内容
    popover: {
      header: {
        courierName: '承运商',
        trackingNumber: '运单号'
      },
      transit: {
        shippingDate: '发货日期'
      },
      error: {
        description: '我们无法获取你的物流信息。请确认运单号。如果正确，可能是数据同步延迟，状态将在可用时更新。',
        updateTrackingNumber: '更新运单号'
      },
      success: {
        copySuccess: '运单号复制成功'
      }
    }
  },

  // 历史数据
  historicalData: {
    // 标题
    title: '该达人在 AhaCreator 的历史表现',
    // 完成合作数量
    completedCollaborations: '在 AhaCreator 已完成的合作',
    // 指标标签
    metrics: {
      averageCpm: '平均 CPM',
      averageCpc: '平均 CPC',
      averageViews: '平均播放量',
      averageClicks: '平均点击量'
    }
  },

  // 合作完成提示
  collaborationComplete: {
    title: '恭喜！本次合作已完成。',
    description: '在 AhaCreator，我们承诺：若达人内容质量较低，或存在虚假播放/互动，可为您全额退款。若发现任何问题，您可以举报该达人，或联系支持团队：',
    reportButton: '举报该达人'
  },

  // 广告报告模态框
  modalAdsReport: {
    // 报告类型
    reportType: {
      additionalPayment: '该达人提出额外费用',
      outsideHead: '该达人希望直接与您沟通',
      notMeetExpectations: '尽管已提前沟通，达人的内容仍与预期不符',
      fakeViewsEngagements: '达人的内容存在刷量或虚假互动',
      otherReasons: '其他原因：'
    },
    // 模态框标题和内容
    modal: {
      title: '举报该达人',
      reportReasonTitle: '为什么要举报该达人？',
      required: '*',
      uploadTitle: '上传截图 / 证明材料',
      uploadDescription: '有助于我们更快为您处理',
      uploadText: '上传',
      reportSubmittedTitle: '已提交举报！',
      reportSubmittedMessage: '我们正在审核，稍后会与您跟进。\n请留意通知！',
      ok: '好的',
      blockInfluencer: '屏蔽达人',
      blockInfluencerDescription: '屏蔽达人，未来不会再邀请他们'
    },
    // 表单相关
    form: {
      placeholder: '请告诉我们您举报该达人的原因…',
      selectReasonWarning: '请选择举报原因',
      submissionFailed: '提交失败，请稍后重试！'
    }
  },

  // 未找到理想达人模态框
  notFindInfluencersModal: {
    // 模态框标题
    title: '没有找到理想的达人？',
    // 有商业信息记录时的内容
    hasBusinessInfo: {
      description: '您审核的达人中有 70% 以上被标记为',
      notMatch: '不匹配',
      description2: '。这通常意味着您的营销计划详情',
      campaignDetails: '（如品牌/产品介绍、目标受众、核心卖点等）',
      description3: '可以适当微调，以提升匹配准确度。',
      description4: '是否希望由 AhaCreator 自动优化计划简报，以获得更理想的达人匹配？当然，您也可以参考下方教程自行优化全部内容。',
      note: '提示：您手动编辑过的内容将保持不变——仅对 AI 生成的部分进行优化。'
    },
    // 没有商业信息记录时的内容
    noBusinessInfo: {
      description: '您的达人通过率低于平均水平（30%+）。达人匹配基于您输入的营销计划信息——包括',
      campaignInfo: '用户画像、核心卖点、品牌/产品介绍',
      description2: '等。试着调整这些信息以提升匹配质量。'
    },
    // 按钮文案
    buttons: {
      notNow: '暂不',
      editManually: '手动编辑营销计划信息',
      optimizeWithAI: '使用 AI 优化'
    },
    // 视频相关
    video: {
      title: 'YouTube 播放器'
    }
  },

  // 订单详情通知
  orderDetailNotice: {
    // 地址提供通知
    addressRequired: {
      description: '该达人需在此时间前提供收货地址：'
    },
    // 内容提交通知
    contentSubmission: {
      description: '该达人预计在{time}之前提交{type}',
      script: '脚本',
      content: '内容',
      productionKickoff: '启动制作',
      productionKickoffDescription: '达人预计在该时间前启动制作：{date}',
      finalLink: '最终链接',
      before: '之前'
    },
    // 账号信息通知
    pendingCreatorAccountInfo: {
      description: '该达人预计在此时间前提交账号信息：{date}'
    },
    // 账号设置通知
    pendingAccountSetup: {
      description: ' 及时反馈建立信任，保持活动在正轨上。'
    }
  },

  // 拒绝信息
  rejectInfo: {
    // 标题
    title: '您曾拒绝',
    // 活动名称
    campaignName: 'The Future of AI',
    // 拒绝时间
    lastRejectedOn: '上次拒绝时间',
    // 拒绝原因
    rejectionReason: '拒绝原因：'
  },

  // 物流详情
  shippingDetail: {
    // 标题
    title: '物流详情',
    // 地址标签
    addressLabels: {
      address: '地址',
      zipCode: '邮编',
      rfc: '税号'
    }
  },

  // 受众画像标题与说明
  audienceDemographics: {
    title: '受众画像',
    aggregatedFromRealUsers: '汇总自真实用户',
    aggregatedFromRealUsersDescription: '这些受众画像基于该达人真实互动用户的样本，包括实际点赞和评论的用户，然后汇总到下面的细分数据中。',
    aggregatedFromRealUsersDescription2: '数据估算方式',
    verifiedData: '真实数据',
    verifiedDataTooltip: '基于该达人已授权账号的数据或其上传的后台截图，显示其已发布内容的实际触达受众。',
    description: '与部分平台使用的模型估算不同，Aha 的真实数据直接来自<b>达人授权账号或提交的后台截图</b> — 更准确的受众参考。',
    modalBuildsAudience: {
      title: 'AhaCreator 如何构建受众数据',
      source: '来源',
      sourceDesc: "实际与该达人近期内容互动的用户：点赞、评论和关注者。（Instagram：点赞者，TikTok：评论者和关注者，YouTube：评论者。）",
      volume: '数量',
      volumeDesc: '每达人抽样数百到~1,000个真实互动用户。',
      country: '国家',
      countryDesc: "直接从每个用户的定位字段读取、测量，不是推断。",
      age: '年龄',
      ageDesc: "根据每个用户的公共资料，推断出4个年龄段：13-17 / 18-34 / 35-64 / 65+。",
      gender: '性别',
      genderDesc: "根据每个用户的公共资料，推断出性别：男 / 女。",
      gotIt: '知道了',
    }
  },

  // 受众图表
  audienceCharts: {
    // 年龄图表
    ageChart: {
      title: '年龄'
    },
    // 性别图表
    genderChart: {
      title: '性别'
    },
    // 地理分布图表
    geographies: {
      title: '主要国家',
      targetedGeographyCoverage: '目标地理覆盖率 (%)',
      otherGeographies: '其他地区分布',
      viewMore: '展开更多',
      collapse: '收起',
      items: '个',
      unknown: '未知',
      audienceMatchTitle: '主要市场国家',
      audienceMatchDescription: '基于该达人已授权账号的数据或其上传的后台截图，显示其已发布内容的实际触达受众。',
    }
  },
  ratingInfo: {
    description: '请花点时间留下评价，重点突出交付、质量和沟通等方面。您的反馈有助于我们为您匹配最佳达人，并帮助我们的平台更好为您服务。',
    rateButton: '评价达人',
    rateButton2: '评价合作'
  },
  rateScore: {
    noRatingYet: "暂无评分",
    noRatingYetDescription: "暂无足够活动，无法提供该达人的评分",
    description: '这个分数帮助您快速评估达人在 AhaCreator 平台的整体可靠性和合作表现。它是基于两个关键维度的综合评分：',
    tip1: '<b>品牌反馈：</b>基于品牌对合作、沟通和内容质量的直接反馈。',
    tip2: '<b>平台绩效指标：</b>基于客观平台数据，如按时交付率、响应速度和合作成功率。'
  },
  contentPerformance: {
    title: '互动与活跃度 (最近20篇)',
    engagementRate: '中位互动率',
    views: '播放量 (中位数)',
    likes: '中位点赞数',
    comments: '中位评论数',
    shares: '中位分享数',
    saves: '中位保存数',
    postFrequency: "中位发帖频率",
    postFrequencyUnit: " 帖子/周",
    averageViews: '平均播放量',
    lastUpdatedTime: '最近更新时间',
    engagementRateTipsYoutube: '互动率反映了受众与最近内容的互动程度：（点赞 + 评论） ÷ 帖文播放量',
    engagementRateTipsTiktok: '互动率反映了受众与最近内容的互动程度：（点赞 + 评论 + 分享 + 保存） ÷ 帖文播放量',
    engagementRateTipsInstagram: '互动率反映了受众与最近内容的互动程度：（点赞 + 评论） ÷ 帖文播放量',
    engagementRateTipsLinkedIn: '互动率反映了受众与最近内容的互动程度：（点赞 + 评论 + 分享） ÷ 帖文播放量',
    engagementRateTipsX: '互动率反映了受众与最近内容的互动程度：（点赞 + 评论 + 分享 + 保存） ÷ 帖文播放量',
    engagementQuality: '互动质量',
    engagementQualityDescription: '强大的互动质量。评论显示真实的用户讨论，几乎没有机器人存在。整体互动健康状况良好。',
  },
  productDetail: {
    title: '产品详情'
  },
  negotiationRecords: {
    viewNegotiationRecords: '查看价格历史',
    BRAND_RATE_NOT_IN_SCOPE: '请输入一个高于您之前报价的报价。',
    INFLUENCER_RATE_NOT_IN_SCOPE: '品牌方更新了报价，请刷新页面查看最新报价',
    BRAND_OFFER_UPDATED: '达人更新了报价，请刷新页面查看最新报价，然后再确认',
    BRAND_OFFER_UPDATED_BEFORE_CONFIRM: '品牌方更新了报价，请刷新页面查看最新报价，然后再确认',
  },
  notes: {
    title: '备注',
    addNote: '添加备注',
    addEditNote: '添加/编辑备注',
    modalTitle: '添加个人备注',
    visibilityHint: '仅对你自己可见'
  },
  promotionalLink: {
    title: '推广链接'
  },
  // 订单类型描述
  orderTypeDescription: {
    dedicatedVideo: '全片围绕品牌展开，适用于新品发布、深度评测及品牌故事呈现。',
    integratedVideo: '品牌片段，占达人视频至少 30% 的内容 — 经济实惠的选项，用于自然但实质性的曝光。',
    reels: '短视频，强大算法触及 — 最佳用于产品发布、病毒趋势和快速品牌曝光。',
    carouselPost: '最多 10 张幻灯片，混合图像和视频。最佳用于故事叙述、产品演示、比较和教程。',
    tiktokVideo: '垂直短视频混合到用户 feed 中 — 强大的 mass reach、创意故事讲述和年轻受众。',
    linkedinVideoPost: '达人领衔视频，分享使用案例、专家意见或 testimonials — 强有力的信任建立和决策者之间的参与。',
    linkedinImagePost: '专业图片帖子，带有文本、图像或视频 — 最佳用于 B2B 品牌、招聘和信誉建立。',
    twitterPost: '灵活帖子，带有文本、图像或视频 — 最佳用于时事关注、品牌声音和病毒传播。'
  },
  // 寄件物流状态
  deliveryStatus: {
    infoReceived: '取件中',
    transit: '运输中',
    outForDelivery: '派送中',
    undelivered: '未送达',
    delivered: '已送达',
    notFound: '未找到',
    exception: '包裹异常',
    expired: '已过期',
    pending: '待定',
  },
};
